import { Component, OnInit } from '@angular/core';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-mis-fotos',
  templateUrl: './mis-fotos.component.html',
  styleUrls: ['./mis-fotos.component.scss']
})
export class MisFotosComponent implements OnInit {
  environment = environment.BASE_URL
  data:any;

  respuestaGet:any;
  respuestaFotos:any;

  fotos;
  fotosG;


  clienteId:any;
  grupoId:any;

  datosCliente:any;
  link_drive = '';

  constructor(private _getFondosMolduras:CatalogosService,  private _getData: LoginService,) { }

  ngOnInit(): void {
    this.getDataCliente();

  }

  getDataCliente(){
    this._getData.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          this.clienteId = this.datosCliente.id;
          this.grupoId = this.datosCliente.grupo;
          this.getFotosCliente(this.clienteId);
          this.getFotosGrupo(this.grupoId);
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getFotosCliente(cliente){
    this.data ={
      'usuario': cliente
    }
    console.log(this.data);
    this._getFondosMolduras.getFotosCliente(this.data).subscribe(
      data => {
        this.respuestaFotos = data;
        if(this.respuestaFotos.success){
          this.fotos = this.respuestaFotos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getFotosGrupo(grupo){
    this.data = {
      'grupo': grupo
    }
    
    this._getFondosMolduras.getFotosGrupo(this.data).subscribe(
      data => {
        this.respuestaFotos = data;
        if(this.respuestaFotos.success){
          this.fotosG = this.respuestaFotos.content;
          this.link_drive = this.respuestaFotos.link_drive;
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  descargarImagen(imagen){
    // var link = document.createElement('a');
    // link.href = this.environment+imagen;
    // link.download = imagen;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);

    var xhr = new XMLHttpRequest();
    var url = this.environment+imagen
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function(){
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = imagen;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    }
    xhr.send();
  }
}
